import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { importPlanogramsModalDataAtom, ImportPlanogramsModalData } from "./atoms";

export const useImportPlanogramsModal = () => {
  const { openModal } = useModals();
  const setImportPlanogramsModalData = useSetAtom(importPlanogramsModalDataAtom);

  const openImportPlanogramsModal = (data: ImportPlanogramsModalData) => {
    setImportPlanogramsModalData(data);
    openModal("ModalImportPlanograms");
  };

  return { openImportPlanogramsModal };
};
